import Icon from 'veui/components/Icon'
import { IconAttribute } from 'dls-icons-vue'

Icon.register('attribute', IconAttribute)
